import GlobalItemDetailsEditModal from './GlobalItemDetailsEditModal';
export default GlobalItemDetailsEditModal;
